import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import MysticalParticles from './MysticalParticles';

const MYOGuidePage = () => {
  return (
    <div className="min-h-screen flex flex-col relative">
      {/* Magical Background */}
      <div className="fixed inset-0 -z-10">
        <img 
          src="https://cdn.4fingerstudios.com/Mystveil/Mystveil_map.png" 
          alt="Mystveil Township Map" 
          className="w-full h-full object-cover opacity-30 blur-sm" 
        />
        <div className="absolute inset-0 bg-gradient-to-br from-purple-900/20 via-pink-900/20 to-purple-900/20"></div>
      </div>

      {/* Magical Particles */}
      <MysticalParticles />

      {/* Navigation */}
      <Navbar />

      {/* Main Content */}
      <main className="flex-grow px-4 py-8">
        <div className="max-w-5xl mx-auto">
          <div className="mystical-card">
            <h1 className="mystical-title text-black mb-8 pb-2 border-b-2 border-purple-500 border-opacity-30">
              Make Your Own Character
            </h1>

            <div className="mystical-card bg-white bg-opacity-95 mb-8">
              <p className="mystical-text text-black leading-relaxed">
                It's time to create your Hatchling! We have a limited amount of slots first available for our beta testers. However there are other ways to earn slots such as winning them in raffles, purchasing them with group currency or USD, earning adopts and so much more! For now however, each member starts with 2 MYO slots for you to use freely.
              </p>
            </div>

            {/* MYO Guide Banner */}
            <div className="w-full mb-8 rounded-xl overflow-hidden shadow-lg mystical-glow">
              <img 
                src="https://cdn.4fingerstudios.com/Mystveil/Example%20grey.png" 
                alt="MYO Guide Banner" 
                className="w-full h-auto block object-cover"
              />
            </div>

            {/* Step One - Hatchling Anatomy */}
            <div className="mystical-card mb-8">
              <h2 className="mystical-subtitle text-black text-2xl text-center mb-8">
                STEP ONE - HATCHLING ANATOMY
              </h2>

              <div className="flex flex-col lg:flex-row gap-8 items-start">
                <div className="w-full lg:w-2/5 rounded-xl overflow-hidden shadow-lg mystical-glow">
                  <img 
                    src="https://cdn.4fingerstudios.com/Mystveil/Example%20green.png" 
                    alt="Hatchling Anatomy" 
                    className="w-full h-auto block object-cover"
                  />
                </div>

                <div className="flex-1">
                  <p className="mystical-text text-black mb-6 leading-relaxed">
                    While your Veilkin may not look like much at the start, they're unique all the same! Here are the basics of a Veilkin Hatchling:
                  </p>

                  <div className="mystical-card bg-purple-500 bg-opacity-10 mb-6">
                    <ul className="space-y-3">
                      <li className="mystical-text text-gray-800">
                        Thick and Stocky bodies, with thick front legs and short back legs.
                      </li>
                      <li className="mystical-text text-gray-800">
                        A jagged jaw, with no teeth.
                      </li>
                      <li className="mystical-text text-gray-800">
                        Three fingered paws, on each of their four feet with a single paw pad. Each finger segmented from each other like hooves.
                      </li>
                      <li className="mystical-text text-gray-800">
                        A heart shaped nose, with a pair of horns that always match in color.
                      </li>
                      <li className="mystical-text text-gray-800">
                        Lined off ridge or "chip" on the top of the heart shaped nose.
                      </li>
                      <li className="mystical-text text-gray-800">
                        A thick and nubby tail, placed on their butt.
                      </li>
                      <li className="mystical-text text-gray-800">
                        Large, round triangle shaped ears with a defined swirl on the inside of the ear.
                      </li>
                    </ul>
                  </div>

                  <p className="mystical-text text-black leading-relaxed">
                    Once approved, all Veilkin can accessorize with any clothing they desire! Please keep in mind that in order to count Chips for any artwork you do, you must stick with these anatomy rules!
                  </p>
                </div>
              </div>
            </div>

            {/* Step Two - Coloring */}
            <div className="mystical-card mb-8">
              <h2 className="mystical-subtitle text-black text-2xl text-center mb-8">
                STEP TWO - COLORING YOUR HATCHLING
              </h2>

              <p className="mystical-text text-black mb-8 leading-relaxed text-center">
                Every MYO Hatchling will start off as one of the MYO Palettes we will have available for our beta. We will go through the different parts of coloring your Hatchling; picking your palette (alongside seeing which ones are available), placement rules and your accent/eye color!
              </p>

              <h3 className="mystical-subtitle text-black text-xl text-center mb-6">
                PICK A COLOR!
              </h3>

              {/* Color Palettes */}
              <div className="flex justify-center mb-8">
                <div className="w-2/3 max-w-xl rounded-xl overflow-hidden shadow-lg mystical-glow">
                  <img 
                    src="https://cdn.4fingerstudios.com/Mystveil/Guide%20images/Color%20pallets%20final.png" 
                    alt="Color Palettes" 
                    className="w-full h-auto block object-cover"
                  />
                </div>
              </div>

              <p className="mystical-text text-black mb-8 leading-relaxed text-center">
                Each palette has Seven colors on it [listed vertically] and you can choose any of those six colors to use as your Hatchling's base color! Your base color can go anywhere that we've colored on the Hatchling shown and should take up most of your Hatchling's body. Next, from the same palette, you may choose up to two additional colors to use as secondary colors on your MYO Hatchling. Finally, your accent color! Your accent color can be any color you want. However, your accent color must match your nose and eye color.
              </p>

              {/* Hatchling Sheets */}
              <div className="space-y-4 mb-8">
                <div className="rounded-xl overflow-hidden shadow-lg mystical-glow">
                  <img 
                    src="https://cdn.4fingerstudios.com/Mystveil/Guide%20images/Mystveil%20Hatchling%20sheet.png" 
                    alt="Hatchling Sheet" 
                    className="w-full h-auto block object-cover"
                  />
                </div>
                <div className="rounded-xl overflow-hidden shadow-lg mystical-glow">
                  <img 
                    src="https://cdn.4fingerstudios.com/Mystveil/Guide%20images/Mystveil%20Hatchling%20sheet%20guide.png" 
                    alt="Hatchling Sheet Guide" 
                    className="w-full h-auto block object-cover"
                  />
                </div>
              </div>

              <h3 className="mystical-subtitle text-black text-xl text-center mb-6">
                PLACEMENTS
              </h3>

              <div className="flex flex-col lg:flex-row gap-8 items-start mb-8">
                <div className="w-full lg:w-2/5">
                  <div className="grid grid-cols-2 gap-4 items-end">
                    <div className="rounded-xl overflow-hidden shadow-lg mystical-glow">
                      <img 
                        src="https://cdn.4fingerstudios.com/Mystveil/art/Art%20of%20Mystveil%20and%20Veilkin/Example%20Pink.png" 
                        alt="Placement Example" 
                        className="w-full h-auto block object-cover"
                      />
                    </div>
                    <div className="rounded-xl overflow-hidden shadow-lg mystical-glow">
                      <img 
                        src="https://cdn.4fingerstudios.com/Mystveil/art/Art%20of%20Mystveil%20and%20Veilkin/Example%20Yellow.png" 
                        alt="Yellow Example" 
                        className="w-full h-auto block object-cover"
                      />
                    </div>
                  </div>
                </div>

                <div className="flex-1">
                  <p className="mystical-text text-black mb-6 leading-relaxed">
                    You may pick your own placements, however:
                  </p>

                  <div className="mystical-card bg-purple-500 bg-opacity-10">
                    <ul className="space-y-3">
                      <li className="mystical-text text-gray-800">
                        They must be simple, rounded and smooth with no sharp points
                      </li>
                      <li className="mystical-text text-gray-800">
                        Should not look like/mimic markings
                      </li>
                      <li className="mystical-text text-gray-800">
                        Your base color should still be clearly the color taking up most of the Hatchling's body
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* Step Three - Application and Approval */}
            <div className="mystical-card mb-8">
              <h2 className="mystical-subtitle text-black text-2xl text-center mb-8">
                STEP THREE - APPLICATION AND APPROVAL
              </h2>

              <div className="mystical-card bg-purple-500 bg-opacity-10 mb-8">
                <p className="mystical-text text-black mb-6 leading-relaxed">
                  Once you've done drawing your Hatchling, you're just about ready to get them approved! How exciting! First thing's first, make sure:
                </p>
                <ul className="space-y-3 list-disc pl-6">
                  <li className="mystical-text text-gray-800">
                    Make sure that the pose you use shows at least one eye, a majority of the placements and the tail
                  </li>
                  <li className="mystical-text text-gray-800">
                    There's no shading or highlights in the image! Your Hatchling should be completely flat colored
                  </li>
                  <li className="mystical-text text-gray-800">
                    Your Hatching should be all four feet on the ground in a standing pose
                  </li>
                  <li className="mystical-text text-gray-800">
                    Make sure your color boxes are filled out with the colors you picked out
                  </li>
                  <li className="mystical-text text-gray-800">
                    If drawing using traditional mediums, make sure you take a picture in natural lighting or use a scanner
                  </li>
                </ul>
              </div>

              <p className="mystical-text text-black mb-8 text-center">
                Below is an example of a completed MYO sheet!
              </p>

              {/* Completed MYO Example */}
              <div className="w-full mb-8 rounded-xl overflow-hidden shadow-lg mystical-glow">
                <img 
                  src="https://cdn.4fingerstudios.com/Mystveil/art/Art%20of%20Mystveil%20and%20Veilkin/Mystveil%20Maisy.png" 
                  alt="Completed MYO Example" 
                  className="w-full h-auto block object-cover"
                />
              </div>

              <div className="mystical-card bg-purple-500 bg-opacity-10 text-center mb-8">
                <p className="mystical-text text-black mb-6 leading-relaxed">
                  Once you're all done, upload your MYO to toyhou.se then comment the following:
                </p>
                <div className="mystical-text text-black leading-relaxed">
                  <p>Name:</p>
                  <p>Gender:</p>
                  <p>Creation: Beta MYO</p>
                  <p>Then link your Chip tracker here!</p>
                </div>
              </div>

              <p className="mystical-text text-black mb-8 text-center">
                Speaking of the Chip tracker, be sure to make a copy of this sheet with your user name on it to keep track of your chips!
              </p>

              <div className="text-center mb-8">
                <a 
                  href="https://docs.google.com/spreadsheets/d/1y-MlGmJXmAzbxZRhELiuCB9xeJogihjSeoLWhhMc66E/edit?usp=sharing" 
                  className="mystical-button"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Chip Tracker
                </a>
              </div>
            </div>

            {/* Navigation Buttons */}
            <div className="flex flex-wrap justify-center gap-4">
              <Link to="/guide" className="mystical-button">
                Back to Guides
              </Link>
              <Link to="/guide/Chip" className="mystical-button">
                Learn About Chips
              </Link>
            </div>
          </div>
        </div>
      </main>

      {/* Mystical Footer */}
      <footer className="mystical-nav py-6 mt-auto">
        <div className="container mx-auto px-4 text-center">
          <p className="mystical-text font-bold">
            © 2025 4fingerstudios <br /> 
            © 2024 Reckless Dreams. All Rights Reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default MYOGuidePage;